/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.headerClone = function () {
    let width = $(window).innerWidth();
    if (width < 950) {
      return false;
    }

    let $win = $(window);
    let fixedheader = $('.js-header').clone().appendTo('body');
    let fixedheaderClone = fixedheader.addClass("js-header-clone");

    fixedheaderClone.removeClass('is-main');

    let showClass = 'is-show';

    $win.on('load scroll', function () {
      var value = $(this).scrollTop();
      if (value > 620) {
        fixedheaderClone.addClass(showClass);
      } else {
        fixedheaderClone.removeClass(showClass);
      }
    });
  };

  growApp.prototype.enterAnimation = function () {
    var $enter = $('.js-enter');
    if (!$('.c-main-visual').length) {
      $enter.toggleClass('is-already');
      return false;
    }
    var win = $(window).innerWidth();
    if (win < 750) {
      $enter.toggleClass('is-already');
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.toggleClass(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {
      // ここから実行
      if ($enter) {
        changeClass($enter, "is-active", 1000).then(function () {
        });
      }
    };

    //first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      $enter.toggleClass('is-already');
    }
  };

  growApp.prototype.parallax = function () {
    class parallax {
      constructor(range, target) {
        this.range = range;
        this.target = target;
        this.fetchDom();
        this.check();
      }
      fetchDom() {
        this.rangeEle = $(this.range);
        this.rangeHeightEle = $(this.range).innerHeight();
        this.targetEle = $(this.target);
      }
      check() {
        if (this.rangeEle.length === 0) {
          return false;
        }
        if (this.target.length === 0) {
          return false;
        }
        this.run();
      }
      run() {
        let $rangeTop = this.rangeEle.offset().top;
        let $rangeHei = this.rangeHeightEle;
        let $target = this.targetEle;
        let isShow = false;
        const options = {
          root: null, // 今回はビューポートをルート要素とする
          rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
          threshold:0
        };
        const observer = new IntersectionObserver(doWhenIntersect, options);

        Array.from(this.rangeEle).forEach(root => {
          observer.observe(root);
        });

        function doWhenIntersect(entries) {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              activateIndex(entry.target);
            } else {
              if ($target.hasClass("is-active")) {
                $target.removeClass("is-active")
              }
            }
          });
        }
        function activateIndex() {
          $target.toggleClass('is-active');

        }
      }
    }
    new parallax(".js-torigger", ".c-block-moving")
  }
  $(function () {
    var app = new growApp();
    app.headerClone();
    app.enterAnimation();
    app.parallax();
  });
})(jQuery);
